import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import checkCircle from 'src/assets/icons/filled-icons/check-circle.svg';

import { ADD_QUOTE_STEPS } from './addQuote.const';
import { IAddQuoteStep } from './addQuote.interface';
import { addQuoteCompletedSteps, addQuoteStops, setAddQuoteStep } from './AddQuote.slice';
import { StepperPersistContext } from './Steps/useStepperPersist';

const Sidebar: FC<{ currentStep: IAddQuoteStep; serviceType?: string | null; stopCount?: number }> = ({ currentStep, serviceType, stopCount = 2 }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const completedSteps = useSelector(addQuoteCompletedSteps);
    // Client decision (Final wording) — a middle stop's tab shows "Stop N · City, Prov" once its
    // address is entered, so the sidebar needs the live stop data, not just the count.
    const stops = useSelector(addQuoteStops);
    const persistRef = useContext(StepperPersistContext);

    const handleStepClick = (step: IAddQuoteStep) => () => {
        if (step.key === currentStep.key) return;
        // Persist the current step's in-flight form values to the slice (no validation) before
        // navigating, so jumping between steps via the sidebar preserves progress. The active
        // step registers this callback via useRegisterStepperPersist.
        persistRef?.current?.();
        dispatch(setAddQuoteStep(step.key));
    };

    return (
        <ul className="stepper-sidebar-wrap space-y-1">
            {ADD_QUOTE_STEPS(t, serviceType, stopCount, stops).map((step, index) => {
                const isActive = currentStep.step === step.step;
                const Icon = step.icon;

                return (
                    <li
                        key={index}
                        className={`vertical-secondary-tab-item ${isActive ? 'vertical-secondary-tab-item-active' : 'cursor-pointer'}`}
                        onClick={handleStepClick(step)}
                        style={{ cursor: !isActive ? 'pointer' : 'default' }}
                    >
                        <div className="vertical-secondary-tab-item-icon-wrap">
                            <Icon className="vertical-secondary-tab-item-icon" />
                        </div>
                        <h3 className="vertical-secondary-tab-item-title">{step.title}</h3>
                        {completedSteps.includes(step.key) && (
                            <div>
                                <img src={checkCircle} alt="check" className="vertical-secondary-tab-item-status-icon" />
                            </div>
                        )}
                    </li>
                );
            })}
        </ul>
    );
};

export default Sidebar;
